import { combineReducers } from 'redux';
import applicationReducer from './reducers/applications/applicationReducer';
import bankReducer from './reducers/applications/bankReducer';
import districtReducer from './reducers/applications/districtReducer';
import houseCategoryReducer from './reducers/applications/houseCategoryReducer';
import houseRangeReducer from './reducers/applications/houseRangeReducer';
import loanApplicationReducer from './reducers/applications/loanApplicationReducer';
import loanReducer from './reducers/applications/loanReducer';
import myLoanReducer from './reducers/applications/myLoanReducer';
import specificLoanApplicationReducer from './reducers/applications/specificLoanApplicationReducer';
import upiReducer from './reducers/applications/upiReducer';
import certificateReducer from './reducers/applications/certificateReducer';
import confirmAccountReducer from './reducers/auth/confirmAccountReducer';
import emailReducer from './reducers/auth/emailReducer';
import findAccountReducer from './reducers/auth/findAccountReducer';
import loginReducer from './reducers/auth/loginReducer';
import nidReducer from './reducers/auth/nidReducer';
import phoneReducer from './reducers/auth/phoneReducer';
import registerReducer from './reducers/auth/registerReducer';
import resetPasswordReducer from './reducers/auth/resetPasswordReducer';
import roleReducer from './reducers/roleReducer';
import applicantReducer from './reducers/users/applicantReducer';
import resendEmailReducer from './reducers/users/resendEmailReducer';
import usersReducer from './reducers/users/usersReducer';
import zipCertificateReducer from './reducers/applications/zipCertificateReducer';
import backendUsers from './reducers/backendUsers';
import authReducer from './reducers/auth';
import settingsReducer from './reducers/settings';
import applicationDocs from './reducers/applications';
import commentReducer from './reducers/applications/commentReducer';
import  maritalStatusReducer  from './reducers/applications/maritalStatusReducer';
import notificationReducer from './reducers/applications/notificationReducer';

const rootReducer = combineReducers({
  role: roleReducer,
  register: registerReducer,
  login: loginReducer,
  applicant: applicantReducer,
  nid: nidReducer,
  email: emailReducer,
  phone: phoneReducer,
  account: findAccountReducer,
  reset: resetPasswordReducer,
  confirm: confirmAccountReducer,
  district: districtReducer,
  houseCategory: houseCategoryReducer,
  houseRange: houseRangeReducer,
  banks: bankReducer,
  application: applicationReducer,
  upi: upiReducer,
  loan: loanReducer,
  myLoan: myLoanReducer,
  users: usersReducer,
  email: resendEmailReducer,
  loanApplications: loanApplicationReducer,
  specificLoanApplication: specificLoanApplicationReducer,
  certificate: certificateReducer,
  zipCertificate: zipCertificateReducer,
  backendUsers: backendUsers,
  auth: authReducer,
  settings: settingsReducer,
  applicationDocs: applicationDocs,
  commentApplication: commentReducer,
  maritalStatus: maritalStatusReducer,
  notifications: notificationReducer,
});

export default rootReducer;
